import SkeletonItem from './Skeleton';

export default SkeletonItem;
